import Moment from 'moment'
import _ from 'lodash'

export default (date)=> {
	if (_.isDate(date) || _.isString(date))
		return Moment(date).fromNow()

	return `\#\#NOT A DATE:${date}\#\#`
}
